import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const PREFIX = 'CellStatusChip';

const classes = {
  container: `${PREFIX}-container`,
  label: `${PREFIX}-label`,
  subLabel: `${PREFIX}-subLabel`,
  primary: `${PREFIX}-primary`,
  warning: `${PREFIX}-warning`,
  error: `${PREFIX}-error`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: theme.spacing(0.25),
    padding: theme.spacing(1.5, 2.5),
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
    color: 'rgba(1, 87, 155, 1)',
    backgroundColor: 'rgba(2, 136, 209, 0.12)',
    borderRadius: '100px',
    height: '36px',
    boxSizing: 'border-box',
    textAlign: 'center',
    [`&.${classes.warning}`]: {
      backgroundColor: 'rgba(237, 108, 2, 0.12)',
      color: 'rgba(237, 108, 2, 1)',
    },
    [`&.${classes.error}`]: {
      backgroundColor: 'rgba(211, 47, 47, 0.12)',
      color: 'rgba(211, 47, 47, 1)',
    },
  },
  [`& .${classes.label}`]: {
    fontFamily: 'Source Sans Pro',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '12px',
    letterSpacing: '0.17px',
  },
  [`& .${classes.subLabel}`]: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '12px',
    letterSpacing: '0.17px',
  },
}));

type CellStatusChipProps = {
  variant: string;
  label: string;
  subLabel: string | null;
};

const CellStatusChip = ({ variant, label, subLabel }: CellStatusChipProps) => {
  let className = [classes.container];
  switch (variant) {
    case 'warning':
      className.push(classes.warning);
      break;
    case 'error':
      className.push(classes.error);
      break;
  }
  return (
    <StyledBox className={className.join(' ')}>
      <span className={classes.label}>{label}</span>
      {subLabel && <span className={classes.subLabel}>{subLabel}</span>}
    </StyledBox>
  );
};

export { CellStatusChip };
export type { CellStatusChipProps };
